import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';

function SubscribeCard({ name, price, features, duration, roi }) {
    const { user } = useUser();
    const [error, setError] = useState(false);
    const [errorValue, setErrorValue] = useState();
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const [amount, setAmount] = useState();
    const [loading, setLoading] = useState(false);
    const usdbal = user?.subscription_balance;
    function validateAmount (value){
        setAmount(value);
        if((usdbal * rate) < value || usdbal === 0){
          setError(true);
          setErrorValue(`Your current balance is ${getCurrencySymbol(user?.currency)}0.00. Kindly choose a lower amount or deposit into your account.`);
        }else if(value < (price * rate)){
            setError(true);
            setErrorValue(`The allowed amount is ${getCurrencySymbol(user?.currency)}${price * rate}. Please enter a higher amount.`);
        }else{
            setError(false);
            setErrorValue("");
        }
    }
    const ValidatePlan = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/subscription.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_subscribe: true, subscribe_name: name, amount: amount })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "dashboard";
              }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
          toast.error('There was an issue processing your deposit.')
        })
    }
    return (
      <div className="mycard mb-4">
        <p className="mb-5 text-prime fw-semibold">{name}</p>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Price</p>
            <p className="mb-0 fw-bold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Plan duration</p>
            <p className="mb-0 fw-bold text-white">{duration} Days</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">ROI</p>
            <p className="mb-0 fw-bold text-success">{roi}%</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Features</p>
            <div className="text-end">
                {features
                ?.split("\n")
                .filter(f => f.trim() !== "")
                .map((feature, index) => (
                    <p key={index} className="mb-0 fw-semibold text-white" style={{fontSize: '14px'}}>{feature}</p>
                ))}
            </div>
        </div>
        <label className="fw-semibold mt-3 mb-1">Amount:</label>
        <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
            <input 
            type="text"
            placeholder={price * rate}
            className="inputNone"
            value={amount}
            onChange={(e) => validateAmount(e.target.value)}
            />
            <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
            USD
            </div>
        </div>
        {error && (
            <p className="mb-0 fw-semibold text-danger mt-1" style={{fontSize: '14px'}}>{errorValue}</p>
        )}
        <div className="d-flex align-items-center justify-content-between mt-2">
            <p className="mb-0 text-white fw-semibold" style={{fontSize: '14px'}}>Current balance</p>
            <p className="mb-0 text-white fw-semibold" style={{fontSize: '14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(usdbal * rate)}</p>
        </div>
        <div className={`myBtn w-100 text-center mt-3 ${error || !amount?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!error && amount ? ValidatePlan : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Subscribe'}</div>
      </div>
    )
  }
  
  export default SubscribeCard